<!-- 月卡开通上报接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/comUpwardStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "carLicenseNumber": "粤B49110",
                "cmd": "reportMonthCar",
                "customVipName": "测试月卡类型315",
                "customerName": "18022222222",
                "customerTelphone": "18022222222",
                "favorPrice": 0,
                "formerPrice": 0,
                "operateTime": "20170928103412",
                "operator": "test",
                "parkCode": "2KNTYVWC",
                "payOrigin": 0,
                "payOriginRemark": "退费",
                "paymentMode": 0,
                "paymentModeRemark": "退费",
                "refundPrice": 200,
                "settlementType": 0,
                "ticketRecordType": 2,
                "vipTicketRecordSeq": 846,
                "vipTicketSeq": 77,
                "vipTime": "20170228000000-20170331235959;"
            },
            responseCode: {
                "data": {
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "智慧停车开放平台主动上报停车场开通和续费月卡车辆到第三方接入系统",
                urlPattern:this.commonUrls.third+"reportMonthCar",
                precondition: "VEMS 2.10.5及以上版本",
                fitSystem: "VEMS传统停车场",
                pattern: "第三方接入系统提供接口, 智慧停车开放平台主动请求",
                frequency:"实时触发",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'vipTicketRecordSeq', info2: '是', info3: 'int', info4: '线下VIP操作流水记录序号' },
                        { info1: 'customerName', info2: '是', info3: 'String', info4: '车主姓名' },
                        { info1: 'customerTelphone', info2: '是', info3: 'String', info4: '车主电话' },
                        { info1: 'carLicenseNumber', info2: '是', info3: 'String', info4: '车牌号' },
                        { info1: 'carportNumber', info2: '是', info3: 'String', info4: '车位号' },
                        { info1: 'customVipName', info2: '是', info3: 'String', info4: 'VIP名称' },
                        { info1: 'vipTime', info2: '是', info3: 'String', info4: '有效期，例：20161101000000-20161231235959;20170201000000-20170231235959' },
                        { info1: 'formerPrice', info2: '是', info3: 'Decimal', info4: '原价' },
                        { info1: 'favorPrice', info2: '是', info3: 'Decimal', info4: '结算类型为0则为折后金额，结算类型为1则为充值金额，结算类型为3则为充值次数' },
                        { info1: 'ticketRecordType', info2: '是', info3: 'int', info4: '流水类型（0开通，1续期，2退款）' },
                        { info1: 'operator', info2: '是', info3: 'String', info4: '操作员' },
                        { info1: 'operateTime', info2: '是', info3: 'String', info4: '操作时间' },
                        { info1: 'refundStatus', info2: '否', info3: 'int', info4: '退款状态' },
                        { info1: 'refundPrice', info2: '否', info3: 'Decimal', info4: '退款金额' },
                        { info1: 'vipTicketSeq', info2: '是', info3: 'int', info4: '对应的线下的 VIP-TICKET-SEQ' },
                        { info1: 'remark', info2: '否', info3: 'String', info4: '备注' },
                        { info1: 'paymentMode', info2: '是', info3: 'int', info4: '支付方式（详情请看附录）' },
                        { info1: 'payOrigin', info2: '是', info3: 'int', info4: '支付来源（详情请看附录）' },
                        { info1: 'paymentModeRemark', info2: '否', info3: 'String', info4: '支付方式备注' },
                        { info1: 'payOriginRemark', info2: '否', info3: 'String', info4: '支付来源备注' },
                        { info1: 'settlementType', info2: '是', info3: 'int', info4: '结算类型（0时间结算，1储值结算，2次数结算）' },
                        { info1: 'lockKey', info2: '是', info3: 'String', info4: '数据唯一标识' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [
                        ]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/upward/reportMonthCar.vue